// src/pages/NotFound.jsx
import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NotFoundIcon from "../imagenes/404.png";

const NotFound = () => {

  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        textAlign: 'center',
        paddingTop: '100px',
      }}
    >
      <Box>
        <img
          src={NotFoundIcon}
          alt="Página no encontrada"
          style={{ width: '100%', maxWidth: '300px', marginBottom: '2rem' }}
        />
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Lo sentimos, no pudimos encontrar esta página.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/login')}
          sx={{ marginTop: '20px' }}
        >
          Volver al inicio
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;